import { apiClient } from "@/lib/api-client";
import type { AnalyticsResponse, AnalyticsParams } from "./types";

export const analyticsApi = {
  get: (shortCode: string, params: AnalyticsParams = {}) => {
    const searchParams = new URLSearchParams();
    if (params.from) searchParams.set("from", params.from);
    if (params.to) searchParams.set("to", params.to);
    const qs = searchParams.toString();
    return apiClient.get<AnalyticsResponse>(
      `/v1/analytics/${shortCode}${qs ? `?${qs}` : ""}`,
    );
  },
};
